import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { DeleteSecurityKeyProgress } from '../../../dialogs/delete-security-key-progress/delete-security-key-progress.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

@AutoUnsubscribe()
@Component({
    selector: 'delete-securitykey',
    templateUrl: './delete-securitykey.component.html',
    styleUrls: ['./delete-securitykey.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatTooltipModule
    ]
})
export class DeleteSecuritykeyComponent implements OnInit, OnDestroy {
  deleteKey: UntypedFormGroup;
  isError: boolean = false;
  screenWidth: number;
  subscription: Subscription = new Subscription();
  resizeObservable$: Observable<Event>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<DeleteSecuritykeyComponent>,
    private dialog: MatDialog,
    private _fb: UntypedFormBuilder,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private cryptoService: CryptoService
  ) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.deleteKey = this._fb.group({
      securityKey: ['', [Validators.maxLength(245)]],
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onPercentChangeKey(percent: any) {
    if (this.isError) {
      this.isError = false;
    }

    let number = percent.length;
    if (number > 100) {
      number = 85;
      eval(`document.querySelector(".security-key-textarea-delete .mat-form-field-wrapper .mat-form-field-flex").style.height='${number}px'`);
      eval(
        `document.querySelector(".security-key-textarea-delete .mat-form-field-wrapper .mat-form-field-flex .mat-input-element").style.height='${number}px'`
      );
    } else {
      eval(`document.querySelector(".security-key-textarea-delete .mat-form-field-wrapper .mat-form-field-flex").style.height='${48}px'`);
      eval(
        `document.querySelector(".security-key-textarea-delete .mat-form-field-wrapper .mat-form-field-flex .mat-input-element").style.height='${48}px'`
      );
    }
  }

  verifyAndDelete() {
    if (this.deleteKey.controls['securityKey'].value && this.deleteKey.controls['securityKey'].valid) {
      const payload = {
        sk: this.data.currentKey.sk,
        key: this.deleteKey.controls['securityKey'].value,
        encrypted_key: this.cryptoService.encryptWithPublicKey(this.deleteKey.controls['securityKey'].value, environment.crypto_public_key),
      };

      this.subscription.add(
        this.documentService.deleteSecurityKey(payload).subscribe((res) => {
          if (res.status == 'deleted successfully') {
            this.isError = false;
            this.dialogRef.close({ confirmation: true });

            const delete_progress = this.dialog.open(DeleteSecurityKeyProgress, {
              width: '400px',
              disableClose: true,
              data: { deleteSecurityKey: res },
              position: { right: '0', bottom: '0' },
              hasBackdrop: false,
            });

            this.subscription.add(
              delete_progress.afterClosed().subscribe((res) => {
                if (res.success) {
                  this.toastr.success(`${this.data?.keyName} was deleted successfully`);
                } else {
                  this.toastr.error(`${this.data?.keyName} failed to deleted`);
                }

                this.cd.detectChanges(); // to detect change and update isError to true or false
              })
            );
          } else {
            this.isError = true;
            this.cd.detectChanges(); // to detect change and update isError to true or false
          }
        })
      );
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
